import { render, staticRenderFns } from "./ParametrizacaoAcaoPasso6.vue?vue&type=template&id=7531114e&lang=html"
import script from "./ParametrizacaoAcaoPasso6.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoAcaoPasso6.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacaoAcaoPasso6.vue?vue&type=style&index=0&id=7531114e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports